import {
  Button,
  Drawer,
  InputLabel,
  MenuItem,
  Select,
  type SelectChangeEvent,
} from '@mui/material';
import type { FormEvent } from 'react';
import { useCallback, useEffect, useState } from 'react';
import type { MissionFilterOptions } from '../../../assets/constants/missionFiltering';
import { COPY } from '../../../assets/copy/copy';
import { CaretIcon, CloseIcon, FilterIcon } from '../../../assets/svgs';
import { FlexSpacer } from '../../../components/FlexSpacer/FlexSpacer';
import './MissionActions.scss';

type FiltersAsButtonProps = {
  onFormSubmit: (e: FormEvent<HTMLFormElement>) => void;
  selectedCategory: string | undefined;
  categories: MissionFilterOptions;
  handleCategoryChange: (category: string | undefined) => void;
};

export function FiltersAsButton(props: FiltersAsButtonProps): JSX.Element {
  const { onFormSubmit, selectedCategory, categories, handleCategoryChange } =
    props;

  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [categoryState, setCategoryState] = useState<string | undefined>(
    selectedCategory
  );

  useEffect(() => {
    setCategoryState(selectedCategory);
  }, [selectedCategory]);

  const toggleDrawer = useCallback(
    () => setDrawerOpen((value) => !value),
    [setDrawerOpen]
  );

  const viewResults = useCallback(() => {
    if (categoryState !== selectedCategory) {
      handleCategoryChange(categoryState);
    }
    setDrawerOpen(false);
  }, [categoryState, handleCategoryChange, selectedCategory]);

  const tempSetCategory = useCallback((e: SelectChangeEvent<string>) => {
    setCategoryState(e.target.value);
  }, []);

  return (
    <div>
      <Button className="mission-filters-button" onClick={toggleDrawer}>
        <FilterIcon />
        {COPY.MISSIONS.FILTER}
      </Button>
      <Drawer anchor="left" open={isDrawerOpen} onClose={toggleDrawer}>
        <div className="filter-drawer-content">
          <div className="drawer-header">
            <h4>{COPY.MISSIONS.FILTER}</h4>
            <FlexSpacer />
            <CloseIcon onClick={toggleDrawer} />
          </div>
          <form className="drawer-content" onSubmit={onFormSubmit}>
            <div>
              <div className="label-wrapper">
                <InputLabel id="mission-categories">
                  {COPY.MISSIONS.MISSION_ACTIONS.CATEGORY}
                </InputLabel>
              </div>
              <Select
                IconComponent={CaretIcon}
                value={categoryState ?? 'All'}
                onChange={tempSetCategory}
                id="mission-categories"
                label="Category"
                className="bold selector"
              >
                {categories.map((catProp) => (
                  <MenuItem
                    className={`bold mission-filtering-item ${
                      catProp.className ?? ''
                    }`}
                    key={catProp.displayValue}
                    value={catProp.displayValue}
                  >
                    {catProp.displayValue}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <Button className="view-results" onClick={viewResults}>
              {COPY.MISSIONS.VIEW_RESULTS}
            </Button>
          </form>
        </div>
      </Drawer>
    </div>
  );
}
